import { CookiesKeys } from '@/constants/enums/CookiesEnum';
import { LocalStorageKeys } from '@/constants/enums/LocalStorageEnum';
import type {
  NeedHelpRequset,
  RegisterRequset,
  SMSVerificationRequset
} from '@/models/interface/register';
import { api } from '@/services';
import type { ApiDataResponse } from '@/utils/api';
import { resolveApiData } from '@/utils/api/functions';
import { UtilCommon } from '@/utils/utilCommon';

export const useRegister = () => {
  const registerRequsetMapping = (requestParams: RegisterRequset) => {
    return requestParams;
  };

  const needHelpRequsetMapping = (requestParams: NeedHelpRequset) => {
    return requestParams;
  };

  const mapping = (response: ApiDataResponse<string>) => {
    return {
      ...response.data,
      content: resolveApiData(response)
    };
  };

  const fetchData = async (
    requestParams: SMSVerificationRequset | RegisterRequset | NeedHelpRequset
  ) => {
    const adId = UtilCommon.getCookie(CookiesKeys.AdId);
    const mgm = UtilCommon.getLocalStorage<string>(LocalStorageKeys.MGMCode);
    console.log(mgm)
    if (isNeedHelp(requestParams)) {
      const res = await api.login.needHelp(needHelpRequsetMapping(requestParams));

    } else if (isRegister(requestParams)) {
      const obj: any = { ...requestParams };
      if (mgm && mgm != null) {
        obj.refMGMCode = mgm;
      }
      if (adId && adId != null) {
        obj.ad_id = adId;
      }
      if (requestParams.ad_id) {
        obj.ad_id = requestParams.ad_id;
      }
      const res = await api.login.register(registerRequsetMapping(obj));

      return mapping(res);
    } else {
      const { ...params } = requestParams;
      if (adId && adId != null) {
        params.ad_id = parseInt(adId);
      }
      if (mgm && mgm != null) {
        params.refMGMCode = mgm;
      }
      if (requestParams.ad_id) {
        params.ad_id = requestParams.ad_id;
      }
      const res = await api.login.smsVerification(params);

      return mapping(res);
    }
  };

  function isRegister(
    params: SMSVerificationRequset | RegisterRequset | NeedHelpRequset
  ): params is RegisterRequset {
    return (params as RegisterRequset).sex !== undefined;
  }

  function isNeedHelp(
    params: SMSVerificationRequset | RegisterRequset | NeedHelpRequset
  ): params is NeedHelpRequset {
    return (params as NeedHelpRequset).tel !== undefined;
  }

  return {
    fetchData
  };
};
